import { inject, InjectionKey, ShallowRef } from 'vue'
import { RelationVocabulary } from '@/hexapla-core/domains/lemmas/relation'

/** Where `RelationVocabularyGate` provides the vocabulary it loaded. */
export const RELATION_VOCABULARY: InjectionKey<ShallowRef<RelationVocabulary | null>> = Symbol('relationVocabulary')

/**
 * The relation vocabulary, for an editor or a renderer. Everything that prints
 * or edits relations renders inside `RelationVocabularyGate`, which shows its
 * content only once the vocabulary has loaded.
 */
export const useRelationVocabulary = (): RelationVocabulary => {
  const vocabulary = inject(RELATION_VOCABULARY, null)?.value
  if (!vocabulary) throw new Error('No relation vocabulary: render inside RelationVocabularyGate')
  return vocabulary
}
